module.exports = __webpack_public_path__ + "img/arb.488af32d.png";